import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { FormBuilder } from '@angular/forms';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { HttpParams } from '@angular/common/http';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { DateUtilService } from '../../../../shared/services/date-util.service';
import { ListaPedidoService } from './lista-pedido.service';
import { DatePipe } from '@angular/common';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';
import * as moment from 'moment';

@Component({
  selector: 'ngx-lista-pedido',
  templateUrl: './lista-pedido.component.html',
  styleUrls: ['./lista-pedido.component.scss']
})
export class ListaPedidoComponent implements OnInit {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  public formConsultaPedido = null;
  public listStatus = null;
  public rowData = null;
  public tableLimit = 12;
  public statusPedido = null;
  public customLogin = null;
  /** Auxiliar de máscara CPF/CNPJ (ngx-mask + DocumentoHelper), alinhado ao filtro cnpjVendedor. */
  public cnpjVendedorMaskAux = null;

  constructor(
    private router: Router,
    private datatableService: DatatableService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private paginationService: SpringDatatablePaginationService,
    private encriptyService: EncriptyUtilService,
    private dateUtilService: DateUtilService,
    private service: ListaPedidoService,
    private datePipe: DatePipe,
  ) {

    this.activatedRoute.queryParams.subscribe(params => {

      this.statusPedido = this.encriptyService.decriptyBySecretKey(params.statusPedido);

      let register = {

        'statusPedido': this.statusPedido,

      }

      this.buscaPedido(register);

    });

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listStatus = [

      {
        statusPedido: 'APROVADO',
        descricao: 'APROVADO'
      },

      {
        statusPedido: 'REJEITADO',
        descricao: 'REJEITADO'
      },

      {
        statusPedido: 'PENDENTE',
        descricao: 'PENDENTE'
      },

      {
        statusPedido: 'AGUARDANDO_CERC',
        descricao: 'EM APROVAÇÃO'
      },

    ];    

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formConsultaPedido = this.formBuilder.group({
      empresaComprador: [null],
      cnpjVendedor: [null],
      statusPedido: [null],

    });

  }

  buscaPedido(data?: any, page?: string) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))

    if (page) {
      params = params.append('page', page)
    }

    if (data) {

      if (data.cnpjVendedor != null && String(data.cnpjVendedor).trim() !== '') {
        params = params.append('cnpjVendedor', this.normalizarCnpjCpfParaBackend(data.cnpjVendedor));
      }
      if (data.statusPedido != null) {
        params = params.append('statusPedido', data.statusPedido)
      }

    }

    this.service.consultSalesOrder(params, (response => {

      this.rowData = response.content
      this.rowData = this.rowData.map(data => {

        return {
          id: data.id,
          empresaVendedor: data.empresaVendedor,
          cnpjVendedor: data.cnpjVendedor,
          valor: data.valor,
          operationSign: data.operationSign,
          statusPedido: data.statusPedido,
          dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),

        }

      })

      this.paginationService.setInfo(response)

    }), null);

  }

  detalhePedido(data) {

    let id = data.id;

    let params = {
      'id': id,
    }

    this.router.navigate(['../detalhe-pedido'], { relativeTo: this.activatedRoute, queryParams: params });

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getCpfCnpjMask(): string {
    const ctrl = this.formConsultaPedido && this.formConsultaPedido.get('cnpjVendedor');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjVendedorMaskAux != null && String(this.cnpjVendedorMaskAux).trim() !== ''
        ? this.cnpjVendedorMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }
}
